import React, {useState, useEffect} from 'react'
import Plot from 'react-plotly.js'
import {Select} from 'antd'
import axios from 'axios'
import {Card, OverlayTrigger, Tooltip} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import { useSelectedWeek } from '../../../../../../contexts/SelectedWeekContext';

const {Option} = Select
interface DataItem {
  week: string
  percent: number
  countAll: number
  max: number
  min: number
  geography: string
}
interface DataTrend {
  week: string
  geography: string
  trend: number
}

const PharmacySalesCharts = () => {
const { selectedWeek } = useSelectedWeek('2023-W40');
const [data, setData] = useState<DataItem[]>([])
const [datat, setDatat] = useState<DataTrend[]>([])
const [RegionClass, setRegionClass] = useState([])
const [selectedRegionClass, setSelectedRegionClass] = useState<string[]>([
  "DE"
  ])
  const [selectedRedebleRegionClass, setSelectedRedebleRegionClass] = useState<string>(
    'All Region',
  )
  const [missingData, setMissingData] = useState<DataItem[]>([])

  // Sample data
  const API_URL = process.env.REACT_APP_API_URL
  // function parseRegion(RegionClass: string[]): string {
  //   const parsedString = RegionClass.map((geography) => `geography=${geography}`).join('&')
  //   return parsedString
  // }
  function addMissingWeek(data: DataItem[]): DataItem[] {
    const startWeek = '2023-W34' // First week in the data
    const endWeek = '2024-W18' // Last week in the data
    const existingWeeks = new Set(data.map((item) => item.week)) // Set to store existing weeks
    const missingData: DataItem[] = []
    const newData: DataItem[] = []

    let currentWeek = startWeek

    while (currentWeek !== endWeek) {
      // Move to the next week
      const [year, weekNum] = currentWeek.split('-W')
      const weekNumber = parseInt(weekNum)
      if (weekNumber < 52) {
        currentWeek = `${year}-W${(weekNumber + 1).toString()}`
      } else {
        currentWeek = `${parseInt(year) + 1}-W1`
      }
      if (!existingWeeks.has(currentWeek)) {
        newData.push({
          week: currentWeek,
          percent: 0,
          countAll: 0,
          max: 0,
          min: 0,
          geography: ''
        })
        missingData.push({
          week: currentWeek,
          percent: 0,
          countAll: 0,
          max: 0,
          min: 0,
          geography: ''
        })
      }
    }

    // Find the index to insert the new week
    let insertionIndex = 0
    for (let i = 0; i < data.length; i++) {
      if (data[i].week <= '2023-W52') {
        insertionIndex = i + 1
      } else {
        break
      }
    }
    setMissingData(missingData)
    // Merge existing data with the newly added missing weeks
    const mergedData = [
      ...data.slice(0, insertionIndex),
      ...newData,
      ...data.slice(insertionIndex),
    ].sort((a, b) => {
      const aYear = parseInt(a.week.substring(0, 4), 10)
      const aWeek = parseInt(a.week.substring(a.week.indexOf('-W') + 2), 10)
      const bYear = parseInt(b.week.substring(0, 4), 10)
      const bWeek = parseInt(b.week.substring(b.week.indexOf('-W') + 2), 10)
      if (aYear !== bYear) {
        return aYear - bYear
      } else {
        return aWeek - bWeek
      }
    })

    return mergedData
  }
  function roundToDecimal(num: number, decimalPlaces: number): number {
    const multiplier = Math.pow(10, decimalPlaces)
    return Math.round(num * multiplier) / multiplier
  }
  const fetchData = async (
    geo = selectedRegionClass
    ) => {
    try {
      //const filterRegion = parseRegion(geography)
      const response = await axios.get(
        API_URL + `/drugSalesRespiratorySyndrome/list?geography=${geo}`
      )
      setData(addMissingWeek(response.data))
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error or set a default value for data
      setData([])
    }
  }
  useEffect(() => {
    const fetchData2 = async (geo = selectedRegionClass) => {
      try {
        const response = await axios.get(`${API_URL}/drugSalesRespiratorySyndromeTrend/trend?geography=${geo}&week=${selectedWeek}`)
        console.log(response.data)
        
        setDatat(response.data)
      } catch (error) {
        console.error('Error fetching data:', error)
        // Handle error or set a default value for data
        setData([])
      }
    }

    const listRegionClass = async () => {
      try {
        const response = await axios.get(
          API_URL + '/drugSalesRespiratorySyndrome/listGeography'
        )
        const data = response.data
        setRegionClass(data)
      } catch (error) {
        console.error('Error fetching data:', error)
        return null
      }
    }

  
    listRegionClass()
    fetchData()
    fetchData2(selectedRegionClass)
  }, [selectedRegionClass,selectedWeek])

  const trace4 = {
    x: data.map((entry) => entry.week),
    y: data.map((entry) => entry.countAll),
    type: 'bar',
    marker: {color: '#b0dff9'},
    name: 'total pharmacy drug sales',
  }
  
  const trace1 = {
    x: data.map((entry) => entry.week),
    y: data.map((entry) => roundToDecimal(entry.min, 2)),

    type: 'scatter',
    mode: 'lines',
    yaxis: 'y2',
    line: {color: 'lightgrey', dash: 'dashdot'},
    name: 'min',
    showlegend: false,
  }

  const trace2 = {
    x: data.map((entry) => entry.week),
    y: data.map((entry) => roundToDecimal(entry.max, 2)),
    fill: 'tonexty',
    type: 'scatter',
    yaxis: 'y2',
    mode: 'lines',
    line: {color: '#BBBBBC', dash: 'dashdot'},
    name: 'Statistical range of normal percentage*',
  }
  const trace3 = {
    x: data.map((entry) => entry.week),
    y: data.map((entry) => entry.percent),
    type: 'scatter',
    mode: 'lines',
    yaxis: 'y2',
    marker: {color: '#203879'},
    name: '% of pharmacy drug sales associated with respiratory syndromes',
  }
  const missdata = {
    x: missingData.map((entry) => entry.week),
    y: missingData.map((entry) => entry.percent),
    type: 'scatter',
    mode: 'markers',
    yaxis: 'y2',
    name: 'Missing Data',
    marker: {color: '#000000'},
  }
  

  const plotData = [trace1, trace2, trace3, trace4,missdata]
  const selectedYear = parseInt(selectedWeek.slice(0, 4));
  const selectedWeekNumber = parseInt(selectedWeek.slice(6));
  const startDate = 2023;
  const startWeek = 35;
  const endYear = 2024;
  const endWeek = 18;
  const showArrow = (selectedYear > startDate || (selectedYear === startDate && selectedWeekNumber >= startWeek)) &&
                    (selectedYear < endYear || (selectedYear === endYear && selectedWeekNumber <= endWeek));
  const layout = {
    title:
      '% of pharmacy drug sales associated with respiratory syndromes among all pharmacy drug sales - ' +
      selectedRedebleRegionClass,
    barmode: 'stack',
    bargap: 0.2, // Adjust the gap between bars
    bargroupgap: 0.1, // Adjust the gap between bar groups
    autosize: true,

    annotations: [
      {
        xref: 'paper',
        yref: 'paper',
        x: -0.035,
        xanchor: 'right',
        y: 0.5,
        yanchor: 'bottom',
        text: '#',
        font: {
          size: 25,

          color: '#b0dff9',
        },
        showarrow: false,
      },
      {
        xref: 'paper',
        yref: 'paper',
        x: 1.03,
        xanchor: 'left',
        y: 0.4,
        yanchor: 'bottom',
        text: '%',
        font: {
          size: 16,

          color: '#203879',
        },
        showarrow: false,
      },
      {
        x: selectedWeek,
        y: 0,
        xref: 'x',
        yref: 'y',
        text: showArrow ? 'Selected Week' : '',
        font: {
          family: 'Courier New, monospace',
          size: 16,
          color: '#CC1B1B',
        },
        arrowcolor: '#CC1B1B',
        showarrow: showArrow,
        arrowhead: 7,
        ax: 0,
        ay: -220,
      },
    ],

    xaxis: {
      title: 'Weeks',
      autorange: true,
      type: 'category',
      tickangle: -45,
    },
    yaxis: {
      autorange: true,
    },
    yaxis2: {
      showgrid: false,
      titlefont: {color: '#203879'},
      tickfont: {color: '#203879'},
      overlaying: 'y',
      side: 'right',
      zeroline: false,
    },
    legend: {
      x: 0,
      y: -0.5, // Adjust the value to position the legend as per your requirement
      orientation: 'h', // 'h' for horizontal, 'v' for vertical
    },
  }

  function handleDataChangeAge(value): void {
  //   if (value.includes('all')) {
  //     setSelectedRegionClass([
  //       "DE",
  // "DE.BW",
  // "DE.BY",
  // "DE.BE",
  // "DE.BB",
  // "DE.HB",
  // "DE.HH",
  // "DE.HE",
  // "DE.MV",
  // "DE.NI",
  // "DE.NW",
  // "DE.RP",
  // "DE.SL",
  // "DE.SN",
  // "DE.ST",
  // "DE.SH",
  // "DE.TH"
  //     ])
  //        fetchData([
  //         "DE",
  //         "DE.BW",
  //         "DE.BY",
  //         "DE.BE",
  //         "DE.BB",
  //         "DE.HB",
  //         "DE.HH",
  //         "DE.HE",
  //         "DE.MV",
  //         "DE.NI",
  //         "DE.NW",
  //         "DE.RP",
  //         "DE.SL",
  //         "DE.SN",
  //         "DE.ST",
  //         "DE.SH",
  //         "DE.TH"
  //        ])
  //   } else {
    let readableAge
    switch (value) {
      case 'DE':
        readableAge = 'All regions'
        break
      case 'DE.BW':
        readableAge = 'Baden-Württemberg'
        break
      case 'DE.BY':
        readableAge = 'Bayern'
        break
      case 'DE.BE':
        readableAge = 'Berlin'
        break
      case 'DE.BB':
        readableAge = 'Brandenburg'
        break
      case 'DE.HB':
        readableAge = 'Bremen'
        break
      case 'DE.HH':
        readableAge = 'Hamburg'
        break
      case 'DE.HE':
        readableAge = 'Hessen'
        break
      case 'DE.MV':
        readableAge = 'Mecklenburg-Vorpommern'
        break
      case 'DE.NI':
        readableAge = 'Niedersachsen'
        break
      case 'DE.NW':
        readableAge = 'Nordrhein-Westfalen'
        break
      case 'DE.RP':
        readableAge = 'Rheinland-Pfalz'
        break
      case 'DE.SL':
        readableAge = 'Saarland'
        break
      case 'DE.SN':
        readableAge = 'Sachsen'
        break
      case 'DE.ST':
        readableAge = 'Sachsen-Anhalt'
        break
      case 'DE.SH':
        readableAge = 'Schleswig-Holstein'
        break
      case 'DE.TH':
        readableAge = 'Thüringen'
        break
      default:
        readableAge = 'Unknown'
        break
    }
    setSelectedRedebleRegionClass(readableAge)
      setSelectedRegionClass(value)
         fetchData(value)
    // }


}

return (
  <>
    <div className='mx-4'>
      {/* begin::Row  */}
      <div className='row '>
        <Card className='mb-8'>
          <div className='card'>
            <div className='card-body'>
              <h2 className='text-primary bold'>
                {' '}
                Pharmacy drugs sales associated with respiratory syndromes (Germany){' '}
                <OverlayTrigger
                  placement='right'
                  overlay={
                    <Tooltip id='logo-tooltip' style={{width: '300px'}}>
                      <p>
                        The pharmacy sales data in Germany is based on a research panel of approx.
                        7.000 pharmacies. Relevant drug sales/hand-outs for respiratory diseases
                        (number of pharmacy sales per ATC-category associated with respiratory
                        syndromes) are processed based on the partnering with CompuGroup Medical and
                        its health data trust center docmetric.
                      </p>
                    </Tooltip>
                  }
                >
                  <img
                    style={{width: '12px', marginLeft: '10px'}}
                    alt='logo'
                    src={toAbsoluteUrl('/media/logos/ii.svg')}
                  />
                </OverlayTrigger>
              </h2>
            </div>
            <Card.Body className='row' style={{marginTop: '-35px'}}>
              <div className='row'>
                <label style={{width: '10%'}} className='col-1 mt-3 text-primary fw-medium fs-5'>
                  Region :
                </label>
                <div className='col-6'>
                  <Select
                    variant='borderless'
                    className='border border-gray-500 border-3 rounded'
                    style={{width: '71%'}}
                    size='large'
                    value={selectedRegionClass}
                    onChange={(value) => handleDataChangeAge(value)}
                    //mode='multiple'
                  >
                    {RegionClass.map((category) => {
                      let readableAge
                      switch (category) {
                        case 'DE':
                          readableAge = 'All regions'
                          break
                        case 'DE.BW':
                          readableAge = 'Baden-Württemberg'
                          break
                        case 'DE.BY':
                          readableAge = 'Bayern'
                          break
                        case 'DE.BE':
                          readableAge = 'Berlin'
                          break
                        case 'DE.BB':
                          readableAge = 'Brandenburg'
                          break
                        case 'DE.HB':
                          readableAge = 'Bremen'
                          break
                        case 'DE.HH':
                          readableAge = 'Hamburg'
                          break
                        case 'DE.HE':
                          readableAge = 'Hessen'
                          break
                        case 'DE.MV':
                          readableAge = 'Mecklenburg-Vorpommern'
                          break
                        case 'DE.NI':
                          readableAge = 'Niedersachsen'
                          break
                        case 'DE.NW':
                          readableAge = 'Nordrhein-Westfalen'
                          break
                        case 'DE.RP':
                          readableAge = 'Rheinland-Pfalz'
                          break
                        case 'DE.SL':
                          readableAge = 'Saarland'
                          break
                        case 'DE.SN':
                          readableAge = 'Sachsen'
                          break
                        case 'DE.ST':
                          readableAge = 'Sachsen-Anhalt'
                          break
                        case 'DE.SH':
                          readableAge = 'Schleswig-Holstein'
                          break
                        case 'DE.TH':
                          readableAge = 'Thüringen'
                          break
                        default:
                          readableAge = 'Unknown'
                          break
                      }
                      return (
                        <Option key={category} value={category}>
                          {readableAge}
                        </Option>
                      )
                    })}
                    {/* <Option key={'all'} value={'all'}>
              {'all regions'}
            </Option> */}
                  </Select>
                </div>
                <div className='col-2'></div>
                {/* <div className='col-2'>
                  <div style={{textAlign: 'right'}}>
                    {datat.map((item) => (
                      <div className='text-primary fw-medium fs-6'>
                        Trend (past 5 weeks) :{' '}
                        <div
                          className='border border-gray-500 border-3 rounded'
                          style={{
                            border: 'border border-gray-500 border-3 rounded',
                            display: 'inline-block', // Assure que le div n'occupe que l'espace nécessaire
                            padding: '6px', // Espace à l'intérieur du cadre
                          }}
                        >
                          <i
                            style={{
                              color:
                                item.trend === null
                                  ? 'transparent'
                                  : Number(item.trend) > 45
                                  ? 'red'
                                  : item.trend > 0
                                  ? 'orange'
                                  : 'green',
                              fontSize: '20px',
                              transform: `rotate(${-1 * item.trend}deg)`,
                            }}
                            className='fa-solid fa-arrow-right'
                          ></i>
                        </div>
                      </div>
                    ))}
                  </div>
                </div> */}
              </div>
              <Plot
                style={{width: '100%', height: '500px'}}
                data={plotData}
                layout={layout}
                config={{
                  displaylogo: false,
                  responsive: true,
                }}
              />
              <p className='card-text source'>
                <p className='card-text source mt-2 row'>
                  <i style={{fontSize: '12px'}} className='mb-2'>
                    * The baseline represents the smoothed value from the previous year. Confidence
                    intervals are calculated by determining the critical value using the normal
                    distribution corresponding to a 95% confidence level. The standard deviation is
                    multiplied by this critical value to obtain the margins of error, which are then
                    added and subtracted from the sample mean to define the interval bounds. The
                    computed alert corresponds to a binary value of 0/1 for each week, diagnosis,
                    age group, geographical origin or/and RSS duration. It indicates, when equal to
                    1, that the current case count exceeds the upper bound of the baseline case
                    count.
                  </i>
                  <i>
                    Source:
                    <a className='fw-bold' href='https://www.cgm.com/en'>
                      {' '}
                      CGM/Docmetric
                    </a>
                  </i>{' '}
                </p>
              </p>
            </Card.Body>
          </div>
        </Card>
      </div>
    </div>
  </>
)
}

export default PharmacySalesCharts
